import { Component, OnInit } from '@angular/core';
import { IonicPage,NavController,NavParams,ViewController } from 'ionic-angular';
import { CajaProvider } from '../../providers/caja/caja';
import { Observable } from 'rxjs/Observable';
import { MeseroProvider } from '../../providers/mesero/mesero';
import { Storage } from '@ionic/storage';
import { MODO_DESCONECTADO, NUBE_AWS } from '../../config/url.servicio';
import { UtilsRedux } from '../../providers/redux/utils/utils';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';

@IonicPage()
@Component({
  selector: 'page-usuario-select',
  templateUrl: 'usuario-select.html',
  providers: [ MeseroProvider,CajaProvider,ClienteSelectRedux,UtilsRedux ]
})
export class UsuarioSelectPage {
  data:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  consultarUsuario: boolean = false
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController,
              public clienteSelectRedux: ClienteSelectRedux,
              public utilsRedux: UtilsRedux,
              public storage: Storage,
              public servicio: CajaProvider) {
    if(this.navParams.get('data')){
      this.consultarUsuario = this.navParams.get('consultarUsuario')
      if(this.consultarUsuario) {
        this.buscarValoresSelectStore(this.consultarUsuario);
      } else {
        this.data = this.navParams.get('data')
      }
    } else {
      this.buscarValoresSelectStore(this.consultarUsuario);
    }
  }

  async buscarValoresSelectStore(consultarUsuario: any) {
    let estados: any = await this.utilsRedux.buscarEstadosStore();
    let existeUsuario = estados !== null && estados.estados.usuarioSelect == true ? estados.estados.usuarioSelect : false
      if(!existeUsuario && !consultarUsuario) {
        let clienteSelect: any = await this.clienteSelectRedux.buscarClienteSelectStore();
        this.data = clienteSelect !== undefined && clienteSelect.clienteselect !== undefined &&  clienteSelect.clienteselect.length > 0 ? clienteSelect.clienteselect : []
        if(this.data.length>0) {
          let values: any = this.data.map((items: any) => {
            return {value:items.clientesId,display:items.nombreCliente}
          })
          this.data = values
        }
      } else {
        this.storage.get('companiasId').then(async (val) => {
          this.servicio.buscarUsuarioPorEmpresa(val) .subscribe(
            res => {
              this.data = []
              this.data = res
            },
            err => console.log(err)
          )
      })
      }

  }

  ionViewDidLoad() {
    this.paginaActual = 1;
  }

  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
   this.viewControllers.dismiss(this.item);
  }

  buscar(event) {
    this.buscarTexto = event.value;
  }
  devolverValor(item) {
    this.item = item;
    this.submit();
  }
}



// WEBPACK FOOTER //
// ./src/pages/usuario-select/usuario-select.ts